module.exports = __webpack_public_path__ + "static/n5impactvideo-9e189606fc49a3675c9478283d9b34ba.webm";